import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type CalendarActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const CalendarActivitySection = (props: CalendarActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_Calendar")}
			trackingId="calendar"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_CalendarEvent")}
					subtext={localize("_CalendarEventActivityDescription")}
					attachable={formHandler.for("calendarEvents")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

CalendarActivitySection.displayName = "CalendarActivitySection";
